import { render, staticRenderFns } from "./general.vue?vue&type=template&id=4087f255"
import script from "./general.vue?vue&type=script&lang=ts"
export * from "./general.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports